import Vue from 'vue';
import accountService from '../../../services/account';
import teamMemberService from './../../../services/team_member';

export default {
  data() {
    return {
      loading: false,
      members: [],
    }
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
  },
  async mounted() {
    this.loading = true;
    teamMemberService.get(this);
  },
  methods: {
    deleteTeamMember(id) {
      let vm = this;
      swal({
          title: "Are you sure?",
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>You will not be able to recover this user</div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: 'Yes, delete it!',
          closeOnConfirm: false,
          html: true
        },
        function () {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();
          accountService.deleteTeamMembers(vm, id);
        });
    },
    setupTeamMember() {
      Vue.router.push({
        name: 'new.user.create',
      });
    },
    changeUserStatus(user) {
      let vm = this;
      swal({
          title: "Are you sure?",
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>Would you like to ' + (user.active ? 'deactivate' : 'activate') + ' this user ?</div>',
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Not now",
          confirmButtonClass: "btn-success",
          confirmButtonText: 'Yes, do it!',
          closeOnConfirm: true,
          html: true
        },
        function (isConfirm) {
          if (isConfirm) {
            $(".pulseWarning").hide();
            $(".cancel").addClass("disabled");
            $(".confirm").addClass("disabled");
            $("#loading1").show();
            user.active = !user.active;
            user.change_password = 0;
            accountService.updateTeamMembers(vm, user);
          }

        });
    },

  }
}



// WEBPACK FOOTER //
// ./src/app/pages/account/team/team.js